// src/pages/Admin/AdminLayout.js
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarAccordion from '../../components/SidebarAccordion';
import { SidebarContext } from '../../context/SidebarContext';
import PageLayout from '../PageLayout';
import './AdminLayout.css';
import { 
  FaRegCalendarAlt,  // Series
  FaPlusCircle, 
  FaEye,
  FaUsers,           // Users
  FaThList,
  FaUserPlus,
  FaGraduationCap,   // Programs
  FaFolderOpen,      // Program Categories
  FaCubes,           // Modules
  FaFileAlt,         // Exam Types
  FaCalendarAlt,     // Years (alias as FaCalAlt)
  FaSchool,          // SemestersP
  FaClipboardList,   // Exams
  FaUserGraduate,    // Student
  FaUpload,          // Student uploads
  FaPlug,             // API Gateway
  FaChartBar         // Reports
} from 'react-icons/fa';

const FaCalAlt = FaCalendarAlt;

function AdminLayout() {
  const { sidebarOpen } = useContext(SidebarContext);

  const menuItems = [
    {
      title: 'Series',
      icon: <FaRegCalendarAlt />,
      children: [
        { title: 'Define Series', path: '/admin/series/define', icon: <FaPlusCircle /> },
        { title: 'Series', path: '/admin/series/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Users',
      icon: <FaUsers />,
      children: [
        { title: 'User Categories', path: '/admin/users/category/view', icon: <FaThList /> },
        { title: 'Add User', path: '/admin/users/create', icon: <FaUserPlus /> },
        { title: 'Users', path: '/admin/users/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Programs',
      icon: <FaGraduationCap />,
      children: [
        { title: 'Add Program', path: '/admin/programs/create', icon: <FaPlusCircle /> },
        { title: 'Programs', path: '/admin/programs/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Program Categories',
      icon: <FaFolderOpen />,
      children: [
        { title: 'Add Program Category', path: '/admin/program-categories/create', icon: <FaPlusCircle /> },
        { title: 'Program Categories', path: '/admin/program-categories/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Modules',
      icon: <FaCubes />,
      children: [
        { title: 'Modules', path: '/admin/modules/view', icon: <FaEye /> },
        { title: 'Add Module', path: '/admin/modules/create', icon: <FaPlusCircle /> },
        
      ],
    },
    {
      title: 'Exam Types',
      icon: <FaFileAlt />,
      children: [
        { title: 'Add Exam Type', path: '/admin/exam-types/create', icon: <FaPlusCircle /> },
        { title: 'Exam Types', path: '/admin/exam-types/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Years',
      icon: <FaCalAlt />,
      children: [
        { title: 'Add Year', path: '/admin/years/create', icon: <FaPlusCircle /> },
        { title: 'Years', path: '/admin/years/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Semesters',
      icon: <FaSchool />,
      children: [
        { title: 'Add Semester', path: '/admin/semesters/create', icon: <FaPlusCircle /> },
        { title: 'Semesters', path: '/admin/semesters/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Exams',
      icon: <FaClipboardList />,
      children: [
        
        { title: 'Scheduled Exams', path: '/admin/exams/view', icon: <FaEye /> },
        { title: 'Schedule Exam', path: '/admin/exams/create', icon: <FaCalendarAlt /> },
        { title: 'Add Exam Centre', path: '/admin/exam-centres/create', icon: <FaPlusCircle /> },
        { title: 'Exam Centres', path: '/admin/exam-centres/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'Student',
      icon: <FaUserGraduate />,
      children: [
        { title: 'Add Student', path: '/admin/students/create', icon: <FaPlusCircle /> },

        { title: 'Students', path: '/admin/students/view', icon: <FaEye /> },
      ],
    },
    {
      title: 'API Gateway',
      icon: <FaPlug />,
      children: [
        { title: 'Connection Test', path: '/admin/api-gateway/test', icon: <FaEye /> },
        { title: 'Fetch Selections', path: '/admin/api-gateway/fetch-selections', icon: <FaThList /> },
      ],
    },
    {
      title: 'Reports',
      icon: <FaChartBar />,
      children: [
        { title: 'Candidate Work Status', path: '/admin/reports/candidate-work-status', icon: <FaFileAlt /> },
        { title: 'Scoring Guide Audit Trail', path: '/admin/reports/scoring-guide-audit', icon: <FaFileAlt /> },
      ],
    },
  ];

  return (
    <div className="admin-layout">
      <div className={`admin-layout-body ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <SidebarAccordion menuItems={menuItems} />
        <div className="main-content">
          <PageLayout>
            <Outlet />
          </PageLayout>
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
